import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from 'common/layout';
import { appRouterPaths } from 'shared/contants';
import { HomePage } from 'pages/home';
import { SectionPage } from 'pages/section';

export const AppRouting = () => {
  return (
	<Routes>
	  <Route element={<AppLayout/>}>
		<Route path={appRouterPaths.home} element={<HomePage/>}/>
		<Route path={appRouterPaths.section} element={<SectionPage/>}/>
		<Route path="*" element={<Navigate to={appRouterPaths.home}/>}/>
	  </Route>
	</Routes>
  );
};
